
<h1 >Upload Avatar</h1>
<mat-dialog-content class="border-bottom">
    
    <input type="file" (change)="fileChangeEvent($event)" accept="image/png, image/jpeg, image/jpg" />

<image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="4 / 4"
    [resizeToWidth]="150"
    format="png"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
    [canvasRotation]="0"
></image-cropper>

<img [src]="croppedImage" />

</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
	<button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>